import React from 'react';
import { GlobalProvider } from '../context/GlobalContext';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Navbar from '../components/Navbar';
import Login from '../pages/Login';
import AllProduct from '../pages/AllProduct';
import AddProductPage from '../pages/RnDPages/AddProductPage';
import DetailProduct from '../pages/DetailProduct';
import HomePage from '../pages/HomePage';
import Register from '../pages/Register';
import RegisterRoute from '../components/AuthRoute/RegisterRoute';
import LoginRoute from '../components/AuthRoute/LoginRoute';
import RnDRoute from '../components/RnDRoute/RnDRoute';
import RegularRoute from '../components/AuthRoute/RegularRoute';
import DataGambar from '../pages/RnDPages/DataGambar';
import ManageInputField from '../pages/RnDPages/ManageInputField';
import EditProductPage from '../pages/RnDPages/EditProductPage';
import AllProductTable from '../pages/AllProductTable';
import ViewerPdf from '../pages/ViewerPdf';

const Routers = () => {
  return (
    <>
      <BrowserRouter>
        <GlobalProvider>
          <Routes>
            {/* <Route path="*" element={<Page404 />} /> */}
            <Route
              path="/"
              element={
                // <Layout>
                <>
                  <RegularRoute>
                    <Navbar />
                    <HomePage />
                  </RegularRoute>
                </>
                // </Layout>
              }
            />
            <Route
              path="/products"
              element={
                // <Layout>
                <>
                  <RegularRoute>
                    <Navbar />
                    <AllProduct />
                  </RegularRoute>
                </>
                // </Layout>
              }
            />
            <Route
              path="/products_table"
              element={
                // <Layout>
                <>
                  <RegularRoute>
                    <Navbar />
                    <AllProductTable />
                  </RegularRoute>
                </>
                // </Layout>
              }
            />

            <Route
              path="/pdfviewer/:id"
              element={
                // <Layout>
                <>
                  <RegularRoute>
                    <Navbar />
                    <ViewerPdf />
                  </RegularRoute>
                </>
                // </Layout>
              }
            />
            <Route
              path="/profile"
              element={
                // <Layout>
                <>
                  <Navbar />
                </>
                // </Layout>
              }
            />
            <Route
              path="/products/add_product"
              element={
                // <Layout>
                <>
                  <RnDRoute>
                    <Navbar />
                    <AddProductPage />
                  </RnDRoute>
                </>
                // </Layout>
              }
            />
            <Route
              path="/products/edit_product/:id"
              element={
                // <Layout>
                <>
                  <RnDRoute>
                    <Navbar />
                    <EditProductPage />
                  </RnDRoute>
                </>
                // </Layout>
              }
            />
            <Route
              path="/products/edit_product_image/:id"
              element={
                // <Layout>
                <>
                  <RnDRoute>
                    <Navbar />
                    <DataGambar />
                  </RnDRoute>
                </>
                // </Layout>
              }
            />
            <Route
              path="/manage_input_field/"
              element={
                // <Layout>
                <>
                  <RnDRoute>
                    <Navbar />
                    <ManageInputField />
                  </RnDRoute>
                </>
                // </Layout>
              }
            />
            <Route
              path="/products/:id"
              element={
                // <Layout>
                <>
                  <RegularRoute>
                    <Navbar />
                    <DetailProduct />
                  </RegularRoute>
                  {/* <Footer /> */}
                </>
                // </Layout>
              }
            />
            <Route path="/register" element={<RegisterRoute />} />
            <Route path="/login" element={<LoginRoute />} />
          </Routes>
        </GlobalProvider>
      </BrowserRouter>
    </>
  );
};

export default Routers;
